import { TranslatePipe } from 'src/app/main/http-service';
import { ControlType } from 'src/app/main/modal/body.handler';
import { ButtonType } from 'src/app/main/modal/button.handler';
import { InitButton } from 'src/app/main/modal/modal.button';
import { ModalHandler } from 'src/app/main/modal/modal.handler';
import { AppComponent } from '../app.component';

export function chooseLanguageHandler(languages: {code: string, name: string}[]): ModalHandler {
   const handler: ModalHandler = new ModalHandler();
   handler.title = 'Choose language';
   handler.body = [
      {
         id: 'choose-language',
         field: 'LANG',
         label: 'Language:',
         type: ControlType.select,
         default: 'Choose',
         required: true,
         placeHolder: 'Language',
         options: languages.map((lang) => ({ _id: lang.code, LANG: TranslatePipe.getTranslation(lang.name) })),
         value: AppComponent.languages.find((lang) => lang.locale === TranslatePipe.getLocale())?.code,
      },
   ];
   [handler.buttons] = InitButton({ type: ButtonType.CancelOk, prefix: 'choose-language' }, 1);
   return handler;
}
